// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Localidades_TogglerelacaoResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for toggleRelacao() /localidades/toggleRelacao
 *
 * Toggles a location-franchise relationship.
 * Returns a boolean success flag.
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type Localidades_TogglerelacaoResponseDados = boolean;

export type Localidades_TogglerelacaoResponse = ApiResponse<Localidades_TogglerelacaoResponseDados>;

registerResponseContract('Localidades_TogglerelacaoResponse', {})
